import RedirectToTab from "features/RedirectToTab";
import { CAMPAIGNS, CandidateServicePath } from "utils/constants";

// The campaign lists are rendered as tabs by CampaignsPage. The per-type list routes stay
// registered so every "back to list" redirect keeps working — they bounce to the matching tab.
const RedirectToCampaignTab = ({ type }) => (
  <RedirectToTab
    to={`${CandidateServicePath}${CAMPAIGNS}`}
    tabKey={type}
  />
);

export default RedirectToCampaignTab;
